var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center flex-col py-3 mt-3"},[_c('LoadingIcon',{staticClass:"w-8 h-8",attrs:{"icon":"oval"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }